var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe-container',{attrs:{"iframe-id":"template_iframe","show-iframe":!_vm.isLoading && _vm.templatePreviewContent,"show-empty-state":!_vm.isLoading && !_vm.templatePreviewContent,"empty-state-description":"This template has no preview yet","preview-content":_vm.templatePreviewContent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }